module.exports = __webpack_public_path__ + "static/media/cardback.ca6a5142.png";